<p-toast></p-toast>
<p-card>
    <div style="text-align: center;">
        <p-progressSpinner *ngIf="loading" [style]="{width: '200px', height: '200px'}"></p-progressSpinner>
    </div>
    <div class="card" *ngIf="!loading">
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-12 p-lg-9">
                <label for="empresa" style="font-family: system-ui;">Empresa</label>
                <p-dropdown class="p-inputtext-sm" [options]="empresas" [(ngModel)]="selecionarEmpresa"
                    [showClear]="true" optionLabel="nome_fantasia" placeholder="Selecione a Empresa"></p-dropdown>
            </div>
            <div class="p-col-12 p-md-12 p-lg-3">
                <label for="empresa" style="font-family: system-ui;">Vendedor</label>
                <p-dropdown class="p-inputtext-sm" [options]="vendedores" [(ngModel)]="selecionarVendedores"
                    [showClear]="true" optionLabel="apelido" placeholder="Selecione o Vendedor"></p-dropdown>
            </div>
        </div>

        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-6 p-lg-4">
                <label for="selecionarPeriodo" style="font-family: system-ui;">Período</label>
                <p-dropdown class="p-inputtext-sm" [options]="periodos" [(ngModel)]="selecionarPeriodo"
                    optionLabel="nome" optionValue="nome" (onChange)="onChangePeriodo($event)"></p-dropdown>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
                <label style="font-family: system-ui;">Data Inicial</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
                <label style="font-family: system-ui;">Data Final</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>
            <div class="p-col-12 p-md-6 p-lg-2" style="align-self: flex-end;">
                <button style="height: 39.272px; background-color: rgb(167, 32, 8);" pButton pRipple type="button" label="Pesquisar"
                    class="p-button-raised" (click)="pesquisar()"></button>
            </div>

        </div>
        <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-7">
                <p-table #dt [value]="lista" selectionMode="single"
                    styleClass="p-datatable-sm p-datatable-striped" dataKey="descricaoTitulo" [scrollable]="true"
                    scrollHeight="300px" (onRowSelect)="onRowSelect($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Vistoria</th>
                            <th style="text-align:right;">Total</th>
                            <th style="text-align:right;">Qtd. Vistoria</th>
                            <th style="text-align:right;">Média Vistoria</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-cliente>
                        <tr [pSelectableRow]="cliente">
                            <td><b>{{cliente.descricaoTitulo}}</b></td>
                            <td style="text-align:right;">{{cliente.total_dinheiro_texto}}</td>
                            <td style="text-align:right;">{{cliente.quantidade_vistoria_texto}}</td>
                            <td style="text-align:right;">{{cliente.media_vistoria_texto}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-col-12 p-md-6 p-lg-5">
                <p-chart type="pie" [data]="grafico"></p-chart>
            </div>
        </div>

        <!-- <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-12">
                <p-chart type="polarArea" [data]="grafico_bar"></p-chart>
            </div>
        </div> -->
    </div>
</p-card>

<!-- A - Total orçamento -->
<p-dialog header="A - Total Vistorias" [(visible)]="displayTotalVistoria" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaTotalVistoria" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="font-size:10px">Cliente</th>
                <th style="font-size:10px">Endereço</th>
                <th style="text-align:right;font-size:10px">Valor</th>
                <th style="text-align:center;font-size:10px">Data Aprovação</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="text-align:left;font-size:10px">{{cliente.nome}}</td>
                <td style="text-align: left;font-size:10px">{{cliente.endereco}}</td>
                <td style="text-align:right;font-size:10px">{{cliente.venda_total | currency:'BRL':true}}</td>
                <td style="text-align:center;font-size:10px">{{cliente.aprovacao | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalTotalVistoria}}</b></span>
            <p-button icon="pi pi-check" (click)="displayTotalVistoria=false" label="FECHAR"
                styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM A - Total Vistoria -->

<!-- B - Vistoria Conservação -->
<p-dialog header="B - Vistorias Conservação" [(visible)]="displayVistoriaConservacao" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaVistoriaConservacao" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="font-size:10px">Cliente</th>
                <th style="font-size:10px">Endereço</th>
                <th style="text-align:right;font-size:10px">Valor</th>
                <th style="text-align:center;font-size:10px">Data Aprovação</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="text-align:left;font-size:10px">{{cliente.nome}}</td>
                <td style="text-align: left;font-size:10px">{{cliente.endereco}}</td>
                <td style="text-align:right;font-size:10px">{{cliente.valor_con | currency:'BRL':true}}</td>
                <td style="text-align:center;font-size:10px">{{cliente.data | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalVistoriaConservacao}}</b></span>
            <p-button icon="pi pi-check" (click)="displayVistoriaConservacao=false" label="FECHAR"
                styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM B - Vistoria Conservação -->

<!-- C - Vistoria Manutenção -->
<p-dialog header="C - Vistorias Manutenção" [(visible)]="displayVistoriaManutencao" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaVistoriaManutencao" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="font-size:10px">Cliente</th>
                <th style="font-size:10px">Endereço</th>
                <th style="text-align:right;font-size:10px">Valor</th>
                <th style="text-align:center;font-size:10px">Data Aprovação</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="text-align:left;font-size:10px">{{cliente.nome}}</td>
                <td style="text-align: left;font-size:10px">{{cliente.endereco}}</td>
                <td style="text-align:right;font-size:10px">{{cliente.valor_man | currency:'BRL':true}}</td>
                <td style="text-align:center;font-size:10px">{{cliente.data | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalVistoriaManutencao}}</b></span>
            <p-button icon="pi pi-check" (click)="displayVistoriaManutencao=false" label="FECHAR"
                styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM C - Vistoria Manutenção -->

<!-- D - Vistoria aprovados -->
<p-dialog header="D - Vistorias aprovadas" [(visible)]="displayVistoriaAprovados" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaVistoriaAprovados" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="font-size:10px">Cliente</th>
                <th style="font-size:10px">Endereço</th>
                <th style="text-align:right;font-size:10px">Valor</th>
                <th style="text-align:center;font-size:10px">Data Aprovação</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="text-align:left;font-size:10px">{{cliente.nome}}</td>
                <td style="text-align: left;font-size:10px">{{cliente.endereco}}</td>
                <td style="text-align:right;font-size:10px">{{cliente.venda_total | currency:'BRL':true}}</td>
                <td style="text-align:center;font-size:10px">{{cliente.aprovacao | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalVistoriaAprovados}}</b></span>
            <p-button icon="pi pi-check" (click)="displayVistoriaAprovados=false" label="FECHAR"
                styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM D - Vistoria aprovados -->

<!-- E - Vistoria em negociação -->
<p-dialog header="E - Vistorias em negociação" [(visible)]="displayVistoriaNegociacao" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaVistoriaNegociacao" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="font-size:12px">Cliente</th>
                <th style="font-size:12px">Endereço</th>
                <th style="text-align:right;font-size:12px">Valor</th>
                <th style="text-align:center;font-size:12px">Data</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="text-align:left;font-size:12px">{{cliente.nome}}</td>
                <td style="text-align: left;font-size:12px">{{cliente.endereco}}</td>
                <td style="text-align:right;font-size:12px">{{cliente.venda_total | currency:'BRL':true}}</td>
                <td style="text-align:center;font-size:12px">{{cliente.data | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalVistoriaNegociacao}}</b></span>
            <p-button icon="pi pi-check" (click)="displayVistoriaNegociacao=false" label="FECHAR"
                styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM E - Vistoria em negociação -->

<!-- F - Vistoria perdidos-->
<p-dialog header="F - Vistorias perdidas" [(visible)]="displayVistoriaPerdidos" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaVistoriaPerdidos" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="font-size:12px">Cliente</th>
                <th style="font-size:12px">Endereço</th>
                <th style="text-align:right;font-size:12px">Valor</th>
                <th style="text-align:center;font-size:12px">Data</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="text-align:left;font-size:12px">{{cliente.nome}}</td>
                <td style="text-align: left;font-size:12px">{{cliente.endereco}}</td>
                <td style="text-align:right;font-size:12px">{{cliente.venda_total | currency:'BRL':true}}</td>
                <td style="text-align:center;font-size:12px">{{cliente.data | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalVistoriaPerdidos}}</b></span>
            <p-button icon="pi pi-check" (click)="displayVistoriaPerdidos=false" label="FECHAR"
                styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM F - Vistoria perdidos -->
